import React from 'react';
import tpl from '../templates/gov-list';
import {View} from 'MWComponents';

export default class extends View {
    template = tpl;

    static displayName = 'Gov.List';
}
